/**
 * Try native sharing using the Web Share API
 */
 const nativeWebShare = () => {
  const shareBtn = document.querySelector('.social-share__button');
  const backupShareLinks = document.querySelector('.social-share__links');
  let shareBtnBehaviour = 'show_icons'; // or 'share_data' if navigator.share is supported

  let shareData = {
    title: shareBtn.getAttribute('data-sharetitle'),
    text: shareBtn.getAttribute('data-sharetext'),
    url: shareBtn.getAttribute('data-shareurl'),
  };

  if (!navigator.canShare || !navigator.canShare(shareData)) {
    shareBtnBehaviour = 'show_icons';
  } else {
    shareBtnBehaviour = 'share_data';
  }

  shareBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (shareBtnBehaviour === 'share_data') {
      navigator.share(shareData);
    } else {
      backupShareLinks.style.display = 'flex';
      shareBtn.style.display = 'none';
    }
  });
};

/**
 * Init
 */
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.social-share__button').length > 0) {
    try {
      nativeWebShare();
    } catch (e) {
      console.log(e);
    }
  } else {
  }
});
